import { Injectable } from '@angular/core';
import { AuthToken, JwtHelper } from '@libs/shared/models';
import { BehaviorSubject, map, Observable, of, take } from 'rxjs';
import { UserAuthHandler } from '../../auth.model';

@Injectable({
  providedIn: 'root',
})
export class AppUserAuthHandler extends UserAuthHandler {
  private readonly bearer$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  public setToken(bearer: string): void {
    this.bearer$.next(bearer);
  }

  public override login(): Observable<AuthToken | undefined> {
    return this.bearer$.pipe(
      take(1),
      map(bearer => bearer ? JwtHelper.parseJwt(bearer) : undefined),
    );
  }

  public override refresh(): Observable<AuthToken | undefined> {
    return of(undefined);
  }

  public override logout(): Observable<void> {
    return of(undefined);
  }
}
